import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { throttle } from 'lodash';
import monitorReducersEnhancer from './monitorReducers'
import loggerMiddleware from './logger'
import { txnMiddleware } from './txnMiddleware' //logActionDiff
import { loadState, saveState } from './localStorage';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers'
import rootSaga from './sagas'
import userACL from '../store/access'
import AccParamACL from '../store/acc_param'

const sagaMiddleware = createSagaMiddleware();


export default function configureAppStore() {

  const preloadedState = loadState();

  const store = configureStore({
    reducer: rootReducer(),
    middleware: [sagaMiddleware, txnMiddleware, loggerMiddleware, ...getDefaultMiddleware()],
    preloadedState,
    enhancers: [monitorReducersEnhancer]
  })

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer()))
  }

  sagaMiddleware.run(rootSaga)

  let cid = document.getElementById("compny_id") ? document.getElementById("compny_id").value : 0;
  let segid = document.getElementById("segment_id_hidden") ? document.getElementById("segment_id_hidden").value : 0;
  let uid = document.getElementById("userId") ? document.getElementById("userId").value : 0;
  let domain = document.getElementById("domain") ? document.getElementById("domain").value : '';
  let boxId = document.getElementById("boxId") ? document.getElementById("boxId").value : '';
  let fromDate = document.getElementById("vp_fromdt_hidden") ? document.getElementById("vp_fromdt_hidden").value : '';
  let toDate = document.getElementById("vp_todt_hidden") ? document.getElementById("vp_todt_hidden").value : '';
  let single_entry_value = document.getElementById("single_entry_value") ? document.getElementById("single_entry_value").value : 'n';
  let amtDecimalPlace = document.getElementById("amtDecimalPlace") ? document.getElementById("amtDecimalPlace").value : '2';
  let userName = document.getElementById("userName") ? document.getElementById("userName").value : '';
  let bulkDelete = document.getElementById("bulkDelete") ? document.getElementById("bulkDelete").value : ''


  userACL.init({
    // domain: 'marcopolo',
    // cid: "4798",
    // segid: "4798",
    // uid: "2612",
    // boxId: "RLBMBOX101",
    // fromDate: "01-09-2022",
    // toDate: "11-01-2023",
    // bulkDelete: false,

    domain,
    cid,
    segid,
    uid,
    boxId,
    fromDate,
    toDate,
    bulkDelete
  });
  AccParamACL.init({
    single_entry_value,
    amtDecimalPlace,
    userName,
  })
  store.subscribe(throttle(() => {
    saveState({
      // loginDetails : store.getState().loginDetails,
      // messagesById: store.getState().messagesById,
      // messagesPrimary : store.getState().messagesPrimary
    });
  }), 1000);

  return store
}

